"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HydroTapBridge = exports.Catalogue = exports.State = exports.Tap = exports.LcdModule = exports.Telemetry = exports.LatestTelemetryUpdate = exports.SensorIdentifier = exports.NAMESPACE = exports.Command = exports.Prefs = exports.Msn = void 0;
const effect_1 = require("effect");
const Predicate_1 = require("effect/Predicate");
const binary_1 = require("../../../../binary");
const schema_1 = require("../../../../schema");
const capability_1 = require("../../capability");
const vendor_1 = require("../../vendor");
const _util_1 = require("../_util");
const Base = __importStar(require("../base"));
const command_1 = require("./command");
const common_1 = require("./common");
const failure_mode_1 = require("./failure-mode");
const Msn = __importStar(require("./msn"));
const Prefs = __importStar(require("./prefs"));
const RoutineSequence = __importStar(require("./routine-sequence"));
const sku_1 = require("./sku");
exports.Msn = __importStar(require("./msn"));
exports.Prefs = __importStar(require("./prefs"));
exports.Command = __importStar(require("./command"));
__exportStar(require("./common"), exports);
exports.NAMESPACE = 'Culligan.Device.Class.HydroTapBridge';
const operatingModes = [
    'Standard',
    'Disabled',
    'Factory',
    'Fault',
    'Ota',
    'Startup',
    'Installation',
];
const powerProfiles = ['Standard', 'Eco', 'Sleep'];
const logLevels = ['Debug', 'Silent', 'Warning', 'Trace'];
const connectivity = ['Cellular', 'Wi-Fi', 'Ethernet'];
const Connectivity = Base.makeConnectivity(exports.NAMESPACE, connectivity);
const slots = [
    [capability_1.Consumable.Definition.MicroPurityFilter.MicroPurityFilter],
    [capability_1.Consumable.Definition.CO2Tank.CO2Tank],
];
const alarms = {
    consumableBased: [
        capability_1.Alarm.ConsumableDepleted,
        capability_1.Alarm.ConsumableLowLevel,
        capability_1.Alarm.ConsumableOverused,
        capability_1.Alarm.ConsumableExpired,
    ],
    firmwareBased: [
        capability_1.Alarm.PowerBoardFault,
        capability_1.Alarm.InterfaceFault,
        capability_1.Alarm.WaterLeak,
        capability_1.Alarm.CompressorOverRun,
        capability_1.Alarm.WaterSupplyFailure,
        capability_1.Alarm.HotSensorOpen,
        capability_1.Alarm.HotSensorClosed,
        capability_1.Alarm.ColdSensorOpen,
        capability_1.Alarm.ColdSensorClosed,
        capability_1.Alarm.FloodSensorOpen,
        capability_1.Alarm.CondenserSensorClosed,
        capability_1.Alarm.CondenserSensorOpen,
        capability_1.Alarm.HeaterFuseFault,
        capability_1.Alarm.HeaterDriverFault,
        capability_1.Alarm.CompressorDriverFault,
        capability_1.Alarm.HotSensorDegraded,
        capability_1.Alarm.CondenserOvertemp,
        capability_1.Alarm.PumpFaulty,
        capability_1.Alarm.SteamTooCool,
        capability_1.Alarm.SteamSensorOpen,
        capability_1.Alarm.SteamSensorClosed,
        capability_1.Alarm.OverSteamed,
        capability_1.Alarm.HotTankOverfilled,
        capability_1.Alarm.CompressorFuse,
        capability_1.Alarm.BoilDryProtection,
        capability_1.Alarm.HtbHotTankTimeout,
        capability_1.Alarm.ColdTankTimeout,
        capability_1.Alarm.UvNotPresent,
        capability_1.Alarm.UvOverTemp,
        capability_1.Alarm.UvUnderCurrent,
        capability_1.Alarm.UvOverCurrent,
        capability_1.Alarm.UvCommsError,
    ],
    telemetryBased: [],
};
const commands = [
    ...capability_1.Command.systemCommands,
    ...command_1.commands,
];
const sensors = {
    flood_sensor_triggered: capability_1.Telemetry.Sensor.Boolean({
        name: 'Flood sensor triggered',
        type: capability_1.Telemetry.FloodSensorTriggered,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    flood_sensor_connected: capability_1.Telemetry.Sensor.Boolean({
        name: 'Flood sensor connected',
        type: capability_1.Telemetry.FloodSensorConnected,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    temperature_ntc_boiling: capability_1.Telemetry.Sensor.Number({
        name: 'Hot water temperature',
        type: capability_1.Telemetry.WaterTemperature,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    temperature_ntc_chilled: capability_1.Telemetry.Sensor.Number({
        name: 'Cold water temperature',
        type: capability_1.Telemetry.WaterTemperature,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    temperature_ntc_steam: capability_1.Telemetry.Sensor.Number({
        name: 'Steam temperature',
        type: capability_1.Telemetry.WaterTemperature,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    temperature_ntc_condensor: capability_1.Telemetry.Sensor.Number({
        name: 'Condensor temperature',
        type: capability_1.Telemetry.WaterTemperature,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    usage_energy_kwh: capability_1.Telemetry.Sensor.Number({
        name: 'Aggregate energy usage',
        type: capability_1.Telemetry.EnergyUsage,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    usage_water_delta_dispenses_boiling: capability_1.Telemetry.Sensor.Number({
        name: 'Change in accumulated boiling dispense count',
        type: capability_1.Telemetry.DispenseCount,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    usage_water_delta_dispenses_chilled: capability_1.Telemetry.Sensor.Number({
        name: 'Change in accumulated chilled dispense count',
        type: capability_1.Telemetry.DispenseCount,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    usage_water_delta_dispenses_sparkling: capability_1.Telemetry.Sensor.Number({
        name: 'Change in accumulated sparkling dispense count',
        type: capability_1.Telemetry.DispenseCount,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    usage_water_delta_litres_boiling: capability_1.Telemetry.Sensor.Number({
        name: 'Change in accumulated boiling dispense volume',
        type: capability_1.Telemetry.DispenseVolume,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    usage_water_delta_litres_chilled: capability_1.Telemetry.Sensor.Number({
        name: 'Change in accumulated chilled dispense volume',
        type: capability_1.Telemetry.DispenseVolume,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    usage_water_delta_litres_sparkling: capability_1.Telemetry.Sensor.Number({
        name: 'Change in accumulated sparkling dispense volume',
        type: capability_1.Telemetry.DispenseVolume,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    wifi_rssi: capability_1.Telemetry.Sensor.Number({
        name: 'Wi-Fi RSSI',
        type: capability_1.Telemetry.SignalStrength,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    refrig_idle_avg_on_time: capability_1.Telemetry.Sensor.Number({
        name: 'Refrigeration idle average ON time',
        type: capability_1.Telemetry.RefrigerationCycleTime,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    refrig_idle_avg_off_time: capability_1.Telemetry.Sensor.Number({
        name: 'Refrigeration idle average OFF time',
        type: capability_1.Telemetry.RefrigerationCycleTime,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    refrig_idle_max_cond_temp_24hrs: capability_1.Telemetry.Sensor.Number({
        name: 'Refrigeration idle maximum condenser temperature (24hrs)',
        type: capability_1.Telemetry.WaterTemperature,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    refrig_in_use_avg_on_time: capability_1.Telemetry.Sensor.Number({
        name: 'Refrigeration in-use average ON time',
        type: capability_1.Telemetry.RefrigerationCycleTime,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    refrig_in_use_avg_off_time: capability_1.Telemetry.Sensor.Number({
        name: 'Refrigeration in-use average OFF time',
        type: capability_1.Telemetry.RefrigerationCycleTime,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    refrig_in_use_max_cond_temp_24hrs: capability_1.Telemetry.Sensor.Number({
        name: 'Refrigeration in-use maximum condenser temperature (24hrs)',
        type: capability_1.Telemetry.WaterTemperature,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    usage_water_pct_boiling: capability_1.Telemetry.Sensor.Number({
        name: 'Water usage percentage boiling',
        type: capability_1.Telemetry.WaterUsagePercentage,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    usage_water_pct_chilled: capability_1.Telemetry.Sensor.Number({
        name: 'Water usage percentage chilled',
        type: capability_1.Telemetry.WaterUsagePercentage,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    usage_water_pct_sparkling: capability_1.Telemetry.Sensor.Number({
        name: 'Water usage percentage sparkling',
        type: capability_1.Telemetry.WaterUsagePercentage,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    usage_water_pct_ambient: capability_1.Telemetry.Sensor.Number({
        name: 'Water usage percentage ambient',
        type: capability_1.Telemetry.WaterUsagePercentage,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    co2_reg_pressure_kpag: capability_1.Telemetry.Sensor.Number({
        name: 'CO2 regulator gauge pressure',
        type: capability_1.Telemetry.CO2RegulatorGaugePressure,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    co2_sensor_ADC: capability_1.Telemetry.Sensor.Number({
        name: 'CO2 Mems sensor ADC reading',
        type: capability_1.Telemetry.CO2SensorAdc,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
};
exports.SensorIdentifier = effect_1.Schema.Literal(...effect_1.Record.keys(sensors)).annotations({
    identifier: `${exports.NAMESPACE}.SensorIdentifier`,
});
exports.LatestTelemetryUpdate = effect_1.Schema.Record({ key: exports.SensorIdentifier, value: effect_1.Schema.DateFromNumber })
    .pipe(effect_1.Schema.partialWith({ exact: true }))
    .annotations({
    identifier: `${exports.NAMESPACE}.LatestTelemetryUpdate`,
});
const events = [capability_1.Event.CalibrationCompleted, capability_1.Event.MilestoneAchieved, capability_1.Event.FilterLog];
exports.Telemetry = effect_1.Schema.Struct({
    flood_sensor_triggered: capability_1.Telemetry.FloodSensorTriggered.FromScalar,
    flood_sensor_connected: capability_1.Telemetry.FloodSensorConnected.FromScalar,
    temperature_ntc_boiling: capability_1.Telemetry.WaterTemperature.FromScalar,
    temperature_ntc_chilled: capability_1.Telemetry.WaterTemperature.FromScalar,
    temperature_ntc_steam: capability_1.Telemetry.WaterTemperature.FromScalar,
    temperature_ntc_condensor: capability_1.Telemetry.WaterTemperature.FromScalar,
    usage_energy_kwh: capability_1.Telemetry.EnergyUsage.FromScalar,
    usage_water_delta_dispenses_boiling: capability_1.Telemetry.DispenseCount.FromScalar,
    usage_water_delta_dispenses_chilled: capability_1.Telemetry.DispenseCount.FromScalar,
    usage_water_delta_dispenses_sparkling: capability_1.Telemetry.DispenseCount.FromScalar,
    usage_water_delta_litres_boiling: capability_1.Telemetry.DispenseVolume.FromScalar,
    usage_water_delta_litres_chilled: capability_1.Telemetry.DispenseVolume.FromScalar,
    usage_water_delta_litres_sparkling: capability_1.Telemetry.DispenseVolume.FromScalar,
    wifi_rssi: capability_1.Telemetry.SignalStrength.FromScalar,
    refrig_idle_avg_on_time: capability_1.Telemetry.RefrigerationCycleTime.FromScalar,
    refrig_idle_avg_off_time: capability_1.Telemetry.RefrigerationCycleTime.FromScalar,
    refrig_idle_max_cond_temp_24hrs: capability_1.Telemetry.WaterTemperature.FromScalar,
    refrig_in_use_avg_on_time: capability_1.Telemetry.RefrigerationCycleTime.FromScalar,
    refrig_in_use_avg_off_time: capability_1.Telemetry.RefrigerationCycleTime.FromScalar,
    refrig_in_use_max_cond_temp_24hrs: capability_1.Telemetry.WaterTemperature.FromScalar,
    usage_water_pct_boiling: capability_1.Telemetry.WaterUsagePercentage.FromScalar,
    usage_water_pct_chilled: capability_1.Telemetry.WaterUsagePercentage.FromScalar,
    usage_water_pct_sparkling: capability_1.Telemetry.WaterUsagePercentage.FromScalar,
    usage_water_pct_ambient: capability_1.Telemetry.WaterUsagePercentage.FromScalar,
    co2_reg_pressure_kpag: capability_1.Telemetry.CO2RegulatorGaugePressure.FromScalar,
    co2_sensor_ADC: capability_1.Telemetry.CO2SensorAdc.FromScalar,
}).annotations({
    identifier: `${exports.NAMESPACE}.Telemetry`,
});
const Version = effect_1.Schema.NonEmptyString.pipe(effect_1.Schema.pattern(/^\d+\.\d+$/)).annotations({
    identifier: `${exports.NAMESPACE}.Version`,
    examples: ['1.0', '01.12'],
});
const FirmwareVersion = effect_1.Schema.NonEmptyString.pipe(effect_1.Schema.pattern(/^\d+\.\d+\.\d+$/)).annotations({
    identifier: `${exports.NAMESPACE}.FirmwareVersion`,
    examples: ['1.0.0', '01.12.3'],
});
const RoutineSequenceDescriptor = effect_1.Schema.Struct({
    id: RoutineSequence.Id,
    component: RoutineSequence.Component,
    subSequence: RoutineSequence.SubSequence,
    runningProgress: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true, nullable: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.RoutineSequenceDescriptor`,
});
exports.LcdModule = effect_1.Schema.Struct({
    hwVersion: Version,
    fwAppVersion: FirmwareVersion,
    fwBootVersion: Version,
    fwGfxVersion: FirmwareVersion,
    fwGfxCRC: effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^[\dA-F]{8}$/i)),
    restartCounter: binary_1.Uint32,
}).annotations({
    identifier: `${exports.NAMESPACE}.LcdModule`,
    description: 'LCD module hardware and firmware configuration details',
});
exports.Tap = effect_1.Schema.Struct({
    typeDevice: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString.pipe(effect_1.Schema.maxLength(100)), { exact: true }),
    typeApp: effect_1.Schema.optionalWith(common_1.TapTypeApp, { exact: true }),
    fwVersion: effect_1.Schema.optionalWith(Version, { exact: true }),
    hwVersion: effect_1.Schema.optionalWith(Version, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.Tap`,
    description: 'Tap hardware and software configuration details',
});
exports.State = effect_1.Schema.Struct({
    ...Base.State.fields,
    operatingMode: effect_1.Schema.Literal(...operatingModes),
    powerProfile: effect_1.Schema.Literal(...powerProfiles),
    logLevel: effect_1.Schema.Literal(...logLevels),
    connectivity: effect_1.Schema.optionalWith(Connectivity, { exact: true }),
    wifiModule: effect_1.Schema.optionalWith(effect_1.Schema.Struct({ hwVersion: Version, fwVersion: FirmwareVersion }), {
        exact: true,
    }),
    lcdModule: effect_1.Schema.optionalWith(exports.LcdModule, { exact: true }),
    modelNumber: effect_1.Schema.optionalWith(sku_1.ModelNumber, { exact: true }),
    productNumber: effect_1.Schema.optionalWith(sku_1.ProductNumber, { exact: true }),
    sku: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(schema_1.PrintString), { exact: true }),
    msn: effect_1.Schema.optionalWith(Msn.Msn, { exact: true, nullable: true }),
    routineSequence: effect_1.Schema.optionalWith(RoutineSequenceDescriptor, { exact: true, nullable: true }),
    locationAlias: effect_1.Schema.optionalWith(common_1.LocationAlias, { exact: true }),
    tap: effect_1.Schema.optionalWith(exports.Tap, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.State`,
});
exports.Catalogue = (0, _util_1.makeCatalogue)(slots).annotations({
    identifier: `${exports.NAMESPACE}.Catalogue`,
});
const identifier = `${exports.NAMESPACE}.HydroTapBridge`;
/**
 * @author Hayden Scott - Lead Device Engineer <hayden.scott@zipwater.com>
 */
class HydroTapBridge extends effect_1.Schema.Class(identifier)({
    model: effect_1.Schema.tag('htb'),
    alarms: (0, _util_1.makeActiveAlarms)(alarms),
    consumables: (0, _util_1.makeSlottedConsumables)(slots),
    state: exports.State,
    latestTelemetry: effect_1.Schema.partialWith(exports.Telemetry, { exact: true }),
    latestTelemetryUpdate: effect_1.Schema.optionalWith(exports.LatestTelemetryUpdate, {
        exact: true,
        default: () => ({}),
    }),
    prefs: effect_1.Schema.optionalWith(Prefs.Prefs, { exact: true, default: () => Prefs.DEFAULT_PREFS }),
    vendor: vendor_1.Zip.DeviceInfo,
    ...Base.CommonProps.fields,
}, { identifier }) {
    static code = 'htb';
    static label = 'HydroTap Bridge';
    static category = 'Multi-Functional Tap';
    static operatingModes = operatingModes;
    static powerProfiles = powerProfiles;
    static logLevels = logLevels;
    static alarms = alarms;
    static slots = slots;
    static sensors = sensors;
    static events = events;
    static commands = commands;
    static connectivity = connectivity;
    static connectionGateway = 'AzureIotHub';
    static image = null;
    static State = exports.State;
    static Prefs = Prefs.Prefs;
    static PrefsFromPartial = Prefs.PrefsFromPartial;
    static Telemetry = exports.Telemetry;
    static Catalogue = exports.Catalogue;
    static vendors = [vendor_1.Zip.code];
    static init = (props, dates) => {
        return new this(Base.deviceInitProps({
            operatingMode: 'Standard',
            powerProfile: 'Standard',
            logLevel: 'Silent',
            connectivity: 'Wi-Fi',
        }, slots, null, props, dates));
    };
    get code() {
        return `${this.vendor.code}${this.model}`;
    }
    get consumableAlarms() {
        const filterAlarm = (0, _util_1.checkAlarmOnExpendableConsumable)(this.consumables[0], 0) ??
            (0, _util_1.checkAlarmOnExpirableConsumable)(this.consumables[0], 0);
        const co2Alarm = (0, _util_1.checkAlarmOnDepletableConsumable)(this.consumables[1], 1);
        return [filterAlarm, co2Alarm].filter(Predicate_1.isNotNull);
    }
    telemetryAlarms = [];
    get manufacturingInfo() {
        return (0, effect_1.pipe)(this.state.msn, effect_1.Option.fromNullable, effect_1.Option.flatMap(effect_1.Schema.decodeOption(Msn.ManufacturerInfoFromMsn)));
    }
    get failureModes() {
        return (0, failure_mode_1.getFailureModes)(this);
    }
}
exports.HydroTapBridge = HydroTapBridge;
//# sourceMappingURL=index.js.map